import React from 'react';
import { Router } from 'react-router';
import { renderRoutes } from 'react-router-config';
import routes from './routes';
import './App.less';
import history from './routes/history';

function App(props) {
    return <Router history={history}>{renderRoutes(routes)}</Router>;
}

export default App;
